module.exports = __webpack_public_path__ + "static/media/AI-cover-letter-generator.828e3992.png";